import gql from "graphql-tag";

export const UPDATEUSERPROFILE_MUTATION = gql`
  mutation UpdateUser($updateUserId: String!, $data: UserInput!) {
    updateUser(id: $updateUserId, data: $data)
  }
`;